<template>
    <TitleCommon
        :title="step === 1 ? 'scan' : 'ticket details'"
        :isShowButtonBack="true"
        :isEmitGoBack="step !== 1"
        @on-click-go-back="offShowTicketDetail"
    />
    <ScanTicket v-if="step === 1" :config="config" />
    <DetailTicket v-else :data="dataDetail" :ticketId="ticketId" :ticketType="ticketType" />
</template>
<script>
import EventBus from '@/utils/EventBus';

import ScanTicket from '@/components/scan/scanTicket.vue';
import DetailTicket from '@/components/scan/ticketDetail.vue';
import TitleCommon from '@/components/common/title/index.vue';

export default {
    components: { ScanTicket, DetailTicket, TitleCommon },
    data() {
        return {
            step: 1,
            dataDetail: null,
            ticketId: '',
            ticketType: '',
            config: null,
        };
    },
    created() {
        this.config = this.$store.getters.getConfigOnFeature('scan');

        EventBus.on('on-show-ticket-detail', (payload) => this.onShowTicketDetail(payload));
        EventBus.on('off-show-ticket-detail', (payload) => this.offShowTicketDetail());
    },
    unmounted() {
        EventBus.off('on-show-ticket-detail');
        EventBus.off('off-show-ticket-detail');
    },
    methods: {
        onShowTicketDetail(payload) {
            this.dataDetail = payload.data;
            this.ticketId = payload.ticketId;
            this.ticketType = payload.ticketType;
            this.step = 2;
        },

        offShowTicketDetail() {
            this.dataDetail = null;
            this.ticketId = '';
            this.ticketType = '';
            this.step = 1;
        },
    },
};
</script>
